/*******************************************************************************
For more information on splide, visit their site.
https://splidejs.com/

Note: In order for this slider to work correctly, it MUST have the 'splide'
class on the parent element. To specify which splider to use, just add a
designated class below as a secondary class on the parent element.
*******************************************************************************/

import Splide from '@splidejs/splide';
import '../../node_modules/@splidejs/splide/dist/css/splide.min.css';

if (document.querySelectorAll('.doubleSplide').length) {
    var startPoint = 1;

    if ($(".tire-details-primary-slider").data("length") < 2) {
        startPoint = 0;
    }

    // Create and mount the thumbnails slider.
    var secondarySlider = new Splide( '#secondary-slider', {
        rewind      : true,
        fixedWidth  : 100,
        fixedHeight : 100,
        isNavigation: true,
        gap         : 10,
        focus       : 'center',
        pagination  : false,
        cover       : true,
        arrows:     true,
        start:      startPoint,
    }).mount();

    // Create the main slider.
    var primarySlider = new Splide( '#primary-slider', {
        type        : 'fade',
        // fixedHeight : '100%',

        // Original
        fixedHeight : '23em',

        pagination  : false,
        arrows      : false,
        start       : startPoint,
    });

    primarySlider.sync(secondarySlider).mount();
}

if (document.querySelectorAll('.singleSplide_one').length) {
    new Splide( '#slider_one', {
        type: 'loop',
        perPage: 1,
        pagination  : false,
    }).mount();
}

if (document.querySelectorAll('.singleSplide_one_deals').length) {
    new Splide( '#slider_one_deals', {
        autoHeight : true,
        type: 'loop',
        perPage: 1,
        pagination  : false,
        arrows      : false,
        drag        : false,
        keyboard    : false,
    }).mount();
}

if (document.querySelectorAll('.singleSplide_two').length) {
    new Splide( '#slider_two', {
        autoHeight : true,
        type: 'loop',
        perPage: 2,
        pagination : false,
		breakpoints: {
			1024: {
				perPage: 2,
				pagination : true,
			},
			640: {
				perPage: 1,
				pagination : true,
			},
		}
    }).mount();
}

if (document.querySelectorAll('.singleSplide_three').length) {
    new Splide( '#slider_three', {
        autoHeight : true,
        type: 'loop',
        perPage: 3,
        pagination : false,
		breakpoints: {
			1024: {
				perPage: 2,
				pagination : true,
			},
			640: {
				perPage: 1,
				pagination : true,
			},
		}
    }).mount();
}
